import React from "react";
import "./Header.css";

export default function Header() {
  return (
    <div className="Header">
      <img src="images/logo.svg" alt="Logo" width="22px" />
      <h1>Dictionary</h1>
    </div>
  );
}
